import { customSelect } from "./custom_select";

export class Fabric {
  constructor(count, container) {
    this.count = count;
    this.container = container;
    this.copyContainer = document.querySelector("#fabric-container-copy");
    this.data = [];
  }

  template = (id) => {
    return `  <div class="w-10">
                  <span class="input-container__label">Workstep</span>
                  <input type="text" class="editor-form__input required" name="fabric-workstep-${id}" id="fabric-workstep-${id}">
              </div>
              <div class="w-20 editor-form__custom-select-container">
                  <span class="input-container__label">Pos. code</span>
                  <input type="text" class="editor-form__input required editor-form__custom-select" data-type="lagecode" name="lagecode-${id}" id="lagecode-${id}">
                  <div class="custom-select-list hidden"></div>
              </div>
              <div class="w-40 editor-form__custom-select-container">
                  <span class="input-container__label">Fabric</span>
                  <input type="text" class="editor-form__input required editor-form__custom-select editor-form__fabric" data-type="fabric" name="fabric-${id}" id="fabric-${id}">
                  <div class="custom-select-list hidden"></div>
              </div>
              <div class="w-10">
                  <span class="input-container__label">No</span>
                  <input type="text" class="editor-form__input required editor-form__id" name="fabric-no-${id}" id="fabric-no-${id}">
              </div>
              <div class="w-20">
                  <span class="input-container__label">Width</span>
                  <input type="text" class="editor-form__input required fabric-breite" name="fabric-cm-${id}" id="fabric-cm-${id}">
              </div>
              ${
                id !== 0
                  ? `<div class="fabric-icon-container"><i class="fas fa-trash form-editor__icon" data-remove="fabric" data-id="${id}"></i></div>`
                  : '<div class="fabric-icon-container"></div>'
              }
            `;
  };

  copyTemplate = (id) => {
    return `<div class="w-55">
                  <span class="input-container__label">Fabric</span>
                  <input readonly type="text" class="copy-form__input" data-id="fabric-${id}"
                      id="copy-fabric-${id}">
              </div>
              <div class="w-25 border-left">
                  <span class="input-container__label">No</span>
                  <input readonly type="text" class="copy-form__input" data-id="fabric-no-${id}"
                      id="copy-fabric-no-${id}">
              </div>
              <div class="w-20 border-left copy-form__row-small-font">
                  <span class="input-container__label">Width</span>
                  <input readonly type="text" class="copy-form__input" data-id="fabric-cm-${id}"
                      id="copy-fabric-cm-${id}">
              </div>`;
  };

  renderFields = () => {
    for (let id = 0; id < this.count; id++) {
      const div = document.createElement("div");
      Object.assign(div, {
        className: "editor-form__row editor-form__row--fabric",
        innerHTML: this.template(id),
      });
      this.container.appendChild(div);
      // customSelect.addScrollEventToObject(div);
      // this.addFocusEventsToField(div);
    }
    this.renderCopyFormFields();
  };

  renderCopyFormFields = () => {
    for (let id = 0; id < this.count; id++) {
      const div = document.createElement("div");
      Object.assign(div, {
        className: "copy-form__row copy-form__row-stretch",
        innerHTML: this.copyTemplate(id),
      });
      this.copyContainer.appendChild(div);
    }
  };

  addValuesToFields = () => {
    if (this.data.length === 0) return;
    for (let i = 0; i < this.data.length; i++) {
      const fabricId = this.data.length > i ? this.data[i].fid : "";
      const name = this.data.length > i ? this.data[i].name : "";
      const workstep = this.data.length > i ? this.data[i].arbeitsschritt : "";
      const lagecode = this.data.length > i ? this.data[i].lagecode_name : "";
      const lagecodeId = this.data.length > i ? this.data[i].lagecode_id : "";
      // prettier-ignore
      const unstretched = this.data.length > i ? this.data[i].unstretch : "";
      document.querySelector("#fabric-workstep-" + i).value = workstep;
      document.querySelector("#lagecode-" + i).value = lagecode;
      // prettier-ignore
      document.querySelector("#lagecode-" + i).setAttribute("data-id", lagecodeId);
      document.querySelector("#fabric-" + i).value = name;
      document.querySelector("#fabric-" + i).setAttribute("data-id", fabricId);
      document.querySelector("#fabric-no-" + i).value = fabricId;
      document.querySelector("#fabric-cm-" + i).value = unstretched;
      // prettier-ignore
      document.querySelector("#copy-fabric-" + i).value = workstep + ' ' + lagecode + ' ' + name;
      document.querySelector("#copy-fabric-no-" + i).value = fabricId;
      document.querySelector("#copy-fabric-cm-" + i).value = name;
    }
  };

  addField = () => {
    const div = document.createElement("div");
    Object.assign(div, {
      className: "editor-form__row editor-form__row--fabric",
      innerHTML: this.template(this.count),
    });
    this.addCopyField();
    this.count++;
    this.container.appendChild(div);
    customSelect.addScrollEventToObject(div);
    this.addFocusEventsToField(div);
  };

  addCopyField = () => {
    const div = document.createElement("div");
    Object.assign(div, {
      className: "copy-form__row copy-form__row-stretch",
      innerHTML: this.copyTemplate(this.count),
    });
    this.copyContainer.appendChild(div);
  };

  removeField = (e) => {
    this.count--;
    const iconContainer = e.target.parentElement.parentElement;
    iconContainer.remove();
    this.renderFieldNamesAndIds();
    this.removeCopyFields(e.target.getAttribute("data-id"));
  };

  removeCopyFields = (id) => {
    const rows = this.copyContainer.querySelectorAll(".copy-form__row");
    rows[id].remove();
  };

  renderFieldNamesAndIds = () => {
    const inputFields = this.container.querySelectorAll("input");
    // we have three input in every subcontainer
    let id = 0;
    for (let i = 0; i < inputFields.length; i++) {
      const nameParts = inputFields[i].name.split("-");
      const newName = `${nameParts.slice(0, -1).join("-")}-${id}`;
      inputFields[i].name = newName;
      inputFields[i].id = newName;
      if (i !== 0 && (i + 1) % 3 === 0) id++;
    }
    const icons = document.querySelectorAll(".editor-form__row--fabric i");
    for (let i = 1; i <= icons.length; i++) {
      icons[i - 1].setAttribute("data-id", i);
    }
  };

  addFocusEventsToField = (container) => {
    const elements = container.querySelectorAll(".editor-form__custom-select");
    elements.forEach((element) => {
      element.addEventListener("focus", (e) => {
        customSelect.focusSelect(e);
      });
    });
  };

  setData = (data) => {
    if (!data) return;
    this.data = data;
    this.count = data.length;
  };

  static copyDataToForm = (fieldContainer, id, text, breite) => {
    const fabricRow = fieldContainer.querySelector("input").id.split("-")[2];
    if (fabricRow > document.querySelectorAll(".fabric > div").length) return;
    const elements = fieldContainer.querySelectorAll("input");
    // prettier-ignore
    text = elements[0].value + " " + elements[1].value + " " + elements[2].value;
    // prettier-ignore
    const fabricCopyContainer = document.querySelectorAll(".fabric > div")[fabricRow];
    const fields = fabricCopyContainer.querySelectorAll("input");
    fields[0].value = text;
    fields[1].value = id;
    fields[2].value = breite + " cm";
  };
}
